module.exports = __webpack_public_path__ + "img/a-empty.bb10f766.png";